module.exports = __webpack_public_path__ + "static/media/step-photo-active.25fe3679.svg";